import styled from "styled-components";
import theme from "../styles/theme";

export const ErrorMessage = styled.div`
    position: relative;
    display: block;
    text-align: center;
    color: ${theme.error};
    font-size: 14px;
`;